import { useAtom } from 'jotai';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageId } from '../enum/PageId';
import { usePages } from '../hooks/use-pages';
import { notificationAtom } from '../jotai-atoms/notification.atom';
import { postLiveClassFeedback } from '../services/feedback';
import { NotificationService } from '../services/notification';
import { BackdropType, Modal } from './Modal';
import SurveyButton from './SurveyButton';

export interface ModalSurveyProps {
  exampleBg?: boolean;
  show: boolean;
  onClose: () => void;
}

type FeedbackOptionType = 'happy' | 'sad';

interface FeedbackOption {
  type: FeedbackOptionType;
}

const ModalSurvey: FC<ModalSurveyProps> = ({ show, onClose, exampleBg }) => {
  const __ = useTranslation().t;
  const { pageId, isPublicPage } = usePages();
  const [selectedOption, setSelectedOption] = useState<FeedbackOptionType>();
  const [notification, setNotification] = useAtom(notificationAtom);

  const backdrop: BackdropType = 'static';

  const modalProps = {
    show,
    onClose,
    type: 'survey',
    exampleBg,
    hideCloseButton: true,
    backdrop,
  };

  const feedbackOptions: FeedbackOption[] = [{ type: 'happy' }, { type: 'sad' }];

  const handleSubmit = async (type: FeedbackOptionType) => {
    if (!type) {
      return onClose();
    }

    setSelectedOption(type);

    if (notification) {
      await postLiveClassFeedback({
        survey_result: type,
        live_class_id: notification.data.liveClassId,
      });
      NotificationService.putNotificationRead(notification.data.notificationId);
      setNotification(null);
    }

    onClose();
  };

  if (isPublicPage || pageId === PageId.Play2learnZoom) {
    return null;
  }

  return (
    <Modal {...modalProps}>
      <h2>{__('todayClassFeedback')}</h2>
      <div className="d-flex justify-content-center">
        {feedbackOptions.map(({ type }) => (
          <SurveyButton
            key={type}
            type={type}
            onClick={() => handleSubmit(type)}
            checked={selectedOption === type}
          />
        ))}
      </div>
    </Modal>
  );
};

export default ModalSurvey;
